module.exports = __webpack_public_path__ + "images/canonical-card/join-icon.0297c32ebceac6375418.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/join-icon.svg
// module id = akNT
// module chunks = 2